// OWNER: HELP. Release notes from the repository's CHANGELOG.md.
import { createFileRoute } from '@tanstack/react-router'
import { WhatsNewPage } from '@/help/whats-new/WhatsNewPage'

export const Route = createFileRoute('/help/whats-new')({
  staticData: { crumb: 'What’s new' },
  component: WhatsNewPage,
})
